import { Card, Typography } from "antd";
import "./ContactUs.scss";
import { FormContact } from "./components";
import { MailOutlined } from "@ant-design/icons";

const { Title, Text, Link } = Typography;

export default function ContactUs({ token }) {
  return (
    <Card
      style={{
        border: "none",
        background: `linear-gradient(135deg, ${token?.colorPrimary}08 0%, ${token?.colorSecondaryLogo}08 100%)`,
        borderRadius: 16,
        boxShadow: token?.HeroCard?.shadowLight,
      }}
      className="contactUs-cont"
      classNames={{
        body: "contactUs-cont",
      }}>
      <div className="contactUs-cont__textsWrapper">
        <div className="contactUs-cont__textsWrapper__titleSection">
          <div
            className="contactUs-cont__textsWrapper__iconWrapper"
            style={{
              background: `linear-gradient(135deg, ${token?.colorPrimary} 0%, ${token?.colorSecondaryLogo} 100%)`,
              boxShadow: token?.HeroCard?.shadowMedium,
            }}>
            <MailOutlined
              style={{ color: token?.icons?.whiteIcon, fontSize: 40 }}
            />
          </div>
          <Title level={1} style={{ margin: 0 }}>
            Contact US
          </Title>
        </div>
        <div
          className="contactUs-cont__textsWrapper__divider"
          style={{ backgroundColor: token?.colorPrimary, opacity: 0.2 }}
        />
        <Text className="contactUs-cont__textsWrapper__description">
          Need to get in touch with us? Either fill out the form your inquiry or
          reach out to us directly{" "}
          <Link
            href="mailto:BlackList420@gmail.com"
            className="contactUs-cont__textsWrapper__description">
            BlackList420@gmail.com
          </Link>{" "}
          .
        </Text>
      </div>
      <div className="contactUs-cont__formWrapper">
        <FormContact />
      </div>
    </Card>
  );
}
